import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
// 語系
import { FormattedMessage, useIntl } from "react-intl";
// ui

//
import { useNavigate } from "react-router";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import HeaderRwd from "../../common/components/header/HeaderRwd";
import Logo from "../../common/components/logo/Logo";
import ButtonBasic from "../../common/components/button/ButtonBasic";
import UserAvatarPopup from "./UserAvatarPopup";
import TextButton from "../../common/components/button/TextButton";
import LocaleSwitch from "./LocaleSwitch";
//
import { StoreContext } from "../../store/StoreProvider";
// hooks
import useLocaleRoute from "../../common/hooks/useLocaleRoute";
// utils
// config
import { ROUTE_PATH } from "../../config/CONSTANTS";
// image
import logoImg from "../../../images/logo/logo@2x.png";
import fireAuth from "../../api/firebase/auth/utils";
import urls from "../../api/project/ApiUrls";
import HomeCardLarge from "../home/components/common/HomeCardLarge";
import ButtonMain from "../../common/components/button/ButtonMain";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const getLogo = (props) => <Logo {...props} />;

const getNavButton = ({ text, link, onClick }) => (
  <TextButton
    text={text}
    // href={link}
    onClick={onClick}
    customWidth
    sx={{
      color: "#121212",
    }}
  />
);

const getLogButton = ({ text, variant, link, onClick }) => (
  <ButtonMain
    buttonProps={{
      text,
      sx: {
        width: "72px",
      },
      variant,
      // onClick,
      href: link,
    }}
  />
);

const getUserAvatar = () => <UserAvatarPopup />;

//
const HeaderSystem = () => {
  //
  const intl = useIntl();
  // route
  const navigate = useNavigate();
  // store
  const [state] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // style
  const classes = useStyles();
  // props

  // local state

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const isLoggedIn = fireAuth.isLoggedIn(user);
  const handleShowSna = () => isLoggedIn;
  const handleShowGis = () => isLoggedIn;
  const handleShowLogin = () => !isLoggedIn;
  const handleShowLogout = () => isLoggedIn;
  const handleShowUserAvatar = () => isLoggedIn;

  const desktopLeftEles = [
    // {
    //   ele: getNavButton({
    //     text: intl.formatMessage({
    //       id: "header.sna",
    //       defaultMessage: "SNA",
    //     }),
    //     link: handleLocaleRoute(ROUTE_PATH.Sna),
    //     onClick: () => navigate(handleLocaleRoute(ROUTE_PATH.Sna)),
    //   }),
    //   show: handleShowSna(),
    // },
    // {
    //   ele: getNavButton({
    //     text: intl.formatMessage({
    //       id: "header.gis",
    //       defaultMessage: "GIS",
    //     }),
    //     link: handleLocaleRoute(ROUTE_PATH.Gis),
    //     onClick: () => navigate(handleLocaleRoute(ROUTE_PATH.Gis)),
    //   }),
    //   show: handleShowGis(),
    // },
  ];
  const desktopRightEles = [
    {
      ele: getLogButton({
        text: intl.formatMessage({
          id: "header.login",
          defaultMessage: "登入",
        }),
        variant: "outlined",
        link: handleLocaleRoute(ROUTE_PATH.LogIn),
        // onClick 跟 href 不能同時使用(會觸發2次navigate)
        // onClick: () => navigate(handleLocaleRoute(ROUTE_PATH.LogIn)),
      }),
      show: handleShowLogin(),
    },
    {
      ele: getLogButton({
        text: intl.formatMessage({
          id: "header.signup",
          defaultMessage: "註冊",
        }),
        variant: "gradient",
        link: handleLocaleRoute(ROUTE_PATH.Signup),
        // onClick 跟 href 不能同時使用(會觸發2次navigate)
        // onClick: () => navigate(handleLocaleRoute(ROUTE_PATH.Signup)),
      }),
      show: handleShowLogin(),
    },
    {
      ele: getUserAvatar(),
      show: handleShowUserAvatar(),
    },
    // 語系切換
    {
      ele: <LocaleSwitch />,
      show: true,
    },
  ];

  const handleLogoClick = () => {
    // navigate(handleLocaleRoute(ROUTE_PATH.Home));
  };

  return (
    <>
      <HeaderRwd
        desktop={{
          logo: getLogo({
            imgProps: {
              imgSrc: logoImg,
              imgWidth: 184,
            },
            imgBoxProps: {
              sx: {
                "&:hover": {
                  cursor: "initial",
                },
              },
              onClick: handleLogoClick,
            },
          }),
          left: desktopLeftEles,
          right: desktopRightEles,
        }}
        mobile={{}}
      />
    </>
  );
};

HeaderSystem.propTypes = {};

HeaderSystem.defaultProps = {};

export default HeaderSystem;
